import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

import Search from "../Search/Search";
import Title from "../../common/Title";
import BatchList from "../../common/BatchList";

import useBatchListState from "../../../hooks/useBatchListState";
import { OPERATIONS } from "../../../constants/value";
import { __getChangeNumberBatches } from "../../../api/sim";

const ChangeNumber = ({ client, hideCreateButton }) => {
  const nav = useNavigate();

  const [searchActive, setSearchActive] = useState(false);

  const {
    data,
    loading,
    metaData,
    response,
    statusCategories,
    handlePageChange,
    handlePageSizeChange,
    handleStatusCategoryChange,
  } = useBatchListState(__getChangeNumberBatches, { client });

  return (
    <Box sx={{ width: "100%" }}>
      <Title
        variant="h5"
        sx={{ textTransform: "capitalize" }}
        content={`${client ? client : ""} Number Changes`}
        gutterBottom
      />
      <Search
        key={`${client}-changeNumber`}
        client={client}
        operation={OPERATIONS.change_number}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
      />

      {/* if search not active show as desired */}
      {!searchActive &&
        (response ? (
          <>
            {!hideCreateButton && (
              <Grid container justifyContent="flex-start" spacing={2}>
                <Grid item>
                  <Stack spacing={2} direction="row">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => nav("form")}
                    >
                      {`Change Number`}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            )}
            <BatchList
              data={data}
              loading={loading}
              meta={metaData}
              changeNumber={true}
              statusCategories={statusCategories}
              onStatusCategoryChange={handleStatusCategoryChange}
              handlePageChange={handlePageChange}
              handlePageSizeChange={handlePageSizeChange}
            />
          </>
        ) : (
          <Title content="Please wait..." variant="subtitle2" gutterBottom />
        ))}
    </Box>
  );
};

export default ChangeNumber;
